import { render, staticRenderFns } from "./YLZDevice.vue?vue&type=template&id=088173ea"
import script from "./YLZDevice.vue?vue&type=script&lang=js"
export * from "./YLZDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports